import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import { WithRootTheme } from '../../theme/util';
import GlobalPrimaryActions from './GlobalPrimaryActions';
import GlobalSecondaryActions from './GlobalSecondaryActions';
import GlobalNavigationInner from '../styled/GlobalNavigationInner';
import GlobalNavigationPrimaryContainer from '../styled/GlobalNavigationPrimaryContainer';
import GlobalNavigationSecondaryContainer from '../styled/GlobalNavigationSecondaryContainer';
import { global } from '../../theme/presets';

var GlobalNavigation = function (_PureComponent) {
  _inherits(GlobalNavigation, _PureComponent);

  function GlobalNavigation() {
    _classCallCheck(this, GlobalNavigation);

    return _possibleConstructorReturn(this, (GlobalNavigation.__proto__ || _Object$getPrototypeOf(GlobalNavigation)).apply(this, arguments));
  }

  _createClass(GlobalNavigation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          createIcon = _props.createIcon,
          linkComponent = _props.linkComponent,
          onCreateActivate = _props.onCreateActivate,
          onSearchActivate = _props.onSearchActivate,
          primaryActions = _props.primaryActions,
          primaryIcon = _props.primaryIcon,
          primaryIconAppearance = _props.primaryIconAppearance,
          primaryItemHref = _props.primaryItemHref,
          searchIcon = _props.searchIcon,
          secondaryActions = _props.secondaryActions,
          theme = _props.theme;


      return React.createElement(
        WithRootTheme,
        { provided: theme },
        React.createElement(
          GlobalNavigationInner,
          null,
          React.createElement(
            GlobalNavigationPrimaryContainer,
            null,
            React.createElement(GlobalPrimaryActions, {
              actions: primaryActions,
              createIcon: createIcon,
              linkComponent: linkComponent,
              onCreateActivate: onCreateActivate,
              onSearchActivate: onSearchActivate,
              primaryIcon: primaryIcon,
              primaryIconAppearance: primaryIconAppearance,
              primaryItemHref: primaryItemHref,
              searchIcon: searchIcon
            })
          ),
          React.createElement(
            GlobalNavigationSecondaryContainer,
            null,
            secondaryActions.length ? React.createElement(GlobalSecondaryActions, { actions: secondaryActions }) : null
          )
        )
      );
    }
  }]);

  return GlobalNavigation;
}(PureComponent);

GlobalNavigation.defaultProps = {
  primaryIconAppearance: 'round',
  secondaryActions: [],
  theme: global
};
export default GlobalNavigation;